import { createSlice } from "@reduxjs/toolkit";

const auditSlice = createSlice({
  name: "audit",
  initialState: [],
  reducers: {
    setAudit: (state, action) => action.payload,
  },
});

export const { setAudit } =
auditSlice.actions;
export default auditSlice.reducer;
